import { z } from 'zod/v4';

export const driversImportResultsSchema = z.array(
  z
    .object({
      validationResult: z.string(),
      importResult: z.string(),
      item: z.object({
        driverId: z.string(),
        name: z.string(),
        groups: z
          .array(
            z.object({
              driverGroupName: z.string(),
            })
          )
          .optional()
          .nullable(),
      }),
    })
    .transform((value) => {
      return {
        ...value,
        item: {
          ...value.item,
          Groups: (value.item.groups ?? [])
            .map((group) => group.driverGroupName)
            .join('|'),
        },
      };
    })
);
